import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateIsOpenAddLead } from "../../store/slices/commonSlice";
import {
  addKanbanData,
  fetchKanbanData,
  fetchLeadLogCount,
} from "../../store/slices/kanbanSlice";
import LeadForm from "./LeadForm";
import { RootDispatch, RootState } from "../../store";
import ILeadData from "../../models/LeadData.model";
import dayjs from "dayjs";
import Skeleton from "react-loading-skeleton";

const DataEntryBoard: React.FC = () => {
  const dispatch = useDispatch<RootDispatch>();

  const kanbanCols = useSelector((state: RootState) => state.kanban.columns);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const options = Object.values(kanbanCols).map((column) => column.name);
  const leadLogCount = useSelector(
    (state: RootState) => state.kanban.todayLeadLogCount
  );

  useEffect(() => {
    dispatch(fetchLeadLogCount());
  }, [dispatch]);

  const handleSubmit = async (data: ILeadData) => {
    setIsSubmitting(true);
    try {
      const res = await dispatch(addKanbanData(data));
      if (res.payload) {
        dispatch(fetchKanbanData({}));
        dispatch(fetchLeadLogCount());

        dispatch(updateIsOpenAddLead(false));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderFormSkeleton = () => (
    <div className="p-6 space-y-4">
      <Skeleton height={30} />
      <Skeleton height={30} />
      <Skeleton height={30} />
      <Skeleton height={30} />
      <Skeleton height={150} />
    </div>
  );
  return (
    <div className="min-h-screen p-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="p-6">
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex items-center justify-between space-x-6">
              <div className="flex flex-col">
                <span className="text-xs font-medium text-gray-500">
                  Selected Date
                </span>
                <span className="text-sm font-semibold">
                  {selectedDate
                    ? dayjs(selectedDate).format("DD MMM YYYY")
                    : "Today"}
                </span>
              </div>

              <div className="h-8 w-px bg-gray-200" />

              <div className="flex flex-col">
                <span className="text-xs font-medium text-gray-500">
                  Leads Added
                </span>
                <span className="text-sm font-semibold text-blue-600">
                  {leadLogCount}
                </span>
              </div>

              <div className="h-8 w-px bg-gray-200" />

              <div className="flex flex-col space-y-1">
                <label className="text-xs font-medium text-gray-700">
                  Filter by Date
                </label>
                <div className="flex space-x-2">
                  <input
                    type="date"
                    value={selectedDate || ""}
                    onChange={(e) => {
                      setSelectedDate(e.target.value);
                      dispatch(fetchLeadLogCount(e.target.value || undefined));
                    }}
                    className="p-2 text-sm rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <button
                    onClick={() => {
                      setSelectedDate(null);
                      dispatch(fetchLeadLogCount());
                    }}
                    className="px-3 py-2 text-sm bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {isSubmitting ? (
            renderFormSkeleton()
          ) : (
            <LeadForm
              statusOptions={options}
              onSubmit={handleSubmit}
              onClose={() => dispatch(updateIsOpenAddLead(false))}
              inline
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DataEntryBoard;
